import { t } from 'i18next';

export enum KeyCategory {
  SYMMETRIC = 'SYMMETRIC',
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export const getKeyCategoryLabel = (category: KeyCategory): string => {
  return t(`keyProperties.categories.${category}`);
};
